import { createContext, useContext } from 'react'

import { Authorization } from '../types'

interface AuthContextProps {
  authorization: Authorization | null
  setAuthorization: (authorization: Authorization | null) => void
}

export const AuthContext = createContext<AuthContextProps | undefined>(undefined)

export const useAuthorization = () => {
  const context = useContext(AuthContext)
  if (!context) throw new Error('useAuthorization must be used within an AuthProvider')
  return context
}
